import { module } from 'modujs';
import { html } from '../utils/environment';
import { gsap } from 'gsap';

export default class extends module {
	constructor(m) {
		super(m);

		this.events = {
			click: {
				close: 'toggle',
				submitButton: 'submit',
				closeSuccessNotification: 'closeSuccessNotification'
			}
		}
	}

	init() {

		this.$window = this.$('window')[0];

		this.$form = document.querySelector('.c-contact_form');
		this.$mail = this.$('mail')[0];
		this.$subject = this.$('subject')[0];
		this.$message = this.$('message')[0];
		this.$errors = this.$('error');

		this.$submitButton = this.$('submitButton')[0];

		this.bindCheckMail = this.checkMail.bind(this);
		this.$mail.addEventListener('input', this.bindCheckMail);

		this.bindCheckInput = this.checkInput.bind(this);
		this.$subject.addEventListener('input', this.bindCheckInput);
		this.$message.addEventListener('input', this.bindCheckInput);

		// 0 = e-mail
		// 1 = subject
		// 2 = message
		this.validator = [false, false, false];

		this.isOpen = false;

		const urlParams = new URLSearchParams(window.location.search);

		if (urlParams.get('contact') == 'open') {
			this.toggle();
		}

		this.bindKeydown = this.keydown.bind(this);
		document.addEventListener('keydown',this.bindKeydown);

	}

	keydown(e) {
		if(this.isOpen) {

			if(e.keyCode == 27) {
				this.toggle();
			}
		}
	}

	outsideClick(e) {
		e.preventDefault();

		if (this.$window.contains(e.target)) {
			// Clicked in window
		} else {
			if (this.isOpen) {
				this.toggle();
			}
		}
	}

	toggle() {		
		if (this.isOpen) {
			html.classList.remove('has-contact-open');

			this.call('hide',{},'Scramble','contactTitle');
			window.removeEventListener('click', this.bindOutsideClick);
		} else {
			html.classList.add('has-contact-open');

			this.call('removeAllNotifications', 'Notification');
			
			gsap.delayedCall(0.4,() => {
				this.call('display',{},'Scramble','contactTitle');
			});
			gsap.delayedCall(0.3,() => {
				this.bindOutsideClick = this.outsideClick.bind(this);
				window.addEventListener('click', this.bindOutsideClick);
			});
	
		}

		this.isOpen = !this.isOpen;
	}

	checkMail(e) {
		let value = e.currentTarget.value;
		let valid = false;

		if (value == '') {
			this.$errors.forEach((message) => {
				if (message.getAttribute('data-message') == 'notemail') {
					message.classList.remove('is-active');
				}
			});

		} else {

			this.$errors.forEach((message) => {
				if (message.getAttribute('data-message') == 'empty') {
					message.classList.remove('is-active');
				}
			});

			let mailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;

			if (!value.match(mailRegex)) {
				this.$errors.forEach((message) => {
					if (message.getAttribute('data-message') == 'notemail') {
						message.classList.add('is-active');
					}
				});

			} else {
				this.$errors.forEach((message) => {
					if (message.getAttribute('data-message') == 'notemail') {
						message.classList.remove('is-active');
					}
				});

				valid = true;
			}
		}

		if (valid) {
			this.$mail.parentNode.classList.add('is-valid');
			this.$mail.parentNode.classList.remove('has-error');

			this.validator[0] = true;

		} else {
			this.$mail.parentNode.classList.add('has-error');
			this.$mail.parentNode.classList.remove('is-valid');

			this.validator[0] = false;
		}

		this.validation();
	}

	checkInput(e) {
		let input = e.currentTarget
		let validatorIndex = input.getAttribute('name') == 'contactSubject' ? 1 : 2;

		let value = input.value;

		let valid = false;

		if (value == '') {
			this.$errors.forEach((message) => {
				if (message.getAttribute('data-message') == 'empty') {
					message.classList.add('is-active');
				}
				if (message.getAttribute('data-message') == 'notemail') {
					message.classList.remove('is-active');
				}
			});

		} else {
			this.$errors.forEach((message) => {
				if (message.getAttribute('data-message') == 'empty') {
					message.classList.add('is-active');
				}
				if (message.getAttribute('data-message') == 'notemail') {
					message.classList.remove('is-active');
				}
			});

			valid = true;
		}

		if (valid) {
			input.parentNode.classList.remove('has-error');
			input.parentNode.classList.add('is-valid');

			this.validator[validatorIndex] = true;

		} else {
			input.parentNode.classList.add('has-error');
			input.parentNode.classList.remove('is-valid');

			this.validator[validatorIndex] = false;

		}

		this.validation();
	}

	validation() {
		if (this.validator[0] && this.validator[1] && this.validator[2]) {
			this.$submitButton.classList.add('is-valid');
		} else {
			this.$submitButton.classList.remove('is-valid');
		}
	}

	submit(e) {
		e.preventDefault();

		this.pending();
	}

	pending() {
		html.classList.add('has-contact-pending');

		const url = window.ajax_object.ajaxurl + '?action=' + this.$form.querySelector('input[name="action"]').value;
		fetch(url, {
			method: "POST",
			body: new FormData(this.$form),
		}).then((results) => {
			return results.json();
		}).then((datas) => {
			gsap.delayedCall(2, () => {
				html.classList.remove('has-contact-pending');

				this.success();
			});
		}).catch((error) => {
			gsap.delayedCall(2, () => {
				html.classList.remove('has-contact-pending');

				this.error();
			});
		});
	}

	success() {
		html.classList.add('has-contact-success');

		this.closeSuccessNotificationCallback = gsap.delayedCall(6, () => {
			html.classList.remove('has-contact-success');
			this.toggle();
		});
	}

	closeSuccessNotification() {
		if (this.closeSuccessNotificationCallback != undefined) {
			this.closeSuccessNotificationCallback.kill();
		}

		html.classList.remove('has-contact-success');
		this.toggle();
	}

	error() {
		html.classList.add('has-contact-error');

		gsap.delayedCall(3, () => {
			html.classList.remove('has-contact-error');
		});
	}


	destroy() {

		this.$mail.removeEventListener('input', this.bindCheckMail);
		this.$subject.removeEventListener('input', this.bindCheckInput);
		this.$message.removeEventListener('input', this.bindCheckInput);

		document.removeEventListener('keydown',this.bindKeydown);
	}
}
